<div class="text-center py-8">
  <div class="flex flex-col items-center justify-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-16 w-16 text-gray-400 mb-4"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
      />
    </svg>
    <h3 class="text-lg font-medium text-gray-900 mb-2">
      No hay productos disponibles
    </h3>
    <p class="text-gray-500 text-sm max-w-md">
      Este establecimiento aún no ha subido su menú, pero puedes comunicarte con
      ellos.
    </p>
  </div>
</div>
